import { render, staticRenderFns } from "./matching_recipes.vue?vue&type=template&id=916e740e&scoped=true&"
import script from "./matching_recipes.vue?vue&type=script&lang=js&"
export * from "./matching_recipes.vue?vue&type=script&lang=js&"
import style0 from "./matching_recipes.vue?vue&type=style&index=0&id=916e740e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916e740e",
  null
  
)

export default component.exports